import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment'

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import CategorieSectionDocumentTree from '@components/CategorieSectionDocumentTree';
import JustificationModal from '@components/JustificationModal';
import DeleteAuthorizedModal from '@components/Document/DeleteAuthorizedModal';


import { getDocuments, updateVisibilityStatus, deleteDocument, reOrderDocument, getDetailDocument } from '@actions/documents';
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj, findSectionInTree } from '@utils/general';

import catalogPermissionsId from '@constants/catalogPermissionsId';
import { SECTION_DOCUMENT_ID, LANGUAGE_DEFAULT } from '@constants/general';
import { documentsExceptionsDelete } from '@constants/documents';

import {
  StatusVisible,
  AuthorizedStatus,
  StatusDelete,
  StatusReading
} from '@constants/general'

import './style.scss'

// const DEFAULT_SECTION = 30
const DEFAULT_SECTION = 10

class Documents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      sectionList: [],
      lazyParams: {
        first: 0,
        // rows: 10,
        page: 0,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      showModalDeleteAuthorized: {
        isVisible: false,
        data: null
      },
      selectedNavegationTree: DEFAULT_SECTION,
      selectedNavegationTreeSearch: '',
      selectedLabelNavegationTree: '',
      findText: '',
      sectionsAllIdsSectionsAllowed: []
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { getDocuments } = this.props;
    const { lazyParams, selectedNavegationTree, findText } = this.state;
    this.setState({ loadingTable: true });
    const params = {
      type: 'all',
      section: DEFAULT_SECTION
    };
    if (selectedNavegationTree) params.section = selectedNavegationTree;
    // params.section = 30
    console.log('params', params);

    const response = await getDocuments(params);
    if (!response?.status) {
      if (response.data.length) {

        response.data = this.validateDocumentsByAllowedSections(response.data)

        if (findText) {
          response.data = response.data.filter(item => {
            const getCurrentName = getValueLanguageObj(item.nombre).toUpperCase()
            return getCurrentName.includes(findText.toUpperCase())
          })
        }
      }
      return this.setState({
        sectionList: response.data,
        loadingTable: false,
        selectedNavegationTreeSearch: selectedNavegationTree
      });
    }
    return this.setState({ loadingTable: false, sectionList: [] });
  };

  validateDocumentsByAllowedSections = (data) => {
    const { allowedSections, categoriesSectionCatalog } = this.props
    const { sectionsAllIdsSectionsAllowed } = this.state
    if (allowedSections?.navega === "SOME") {
      const getDocumentsSections = findSectionInTree(SECTION_DOCUMENT_ID, categoriesSectionCatalog)

      let getSectionsAllIdsSectionsAllowed = null
      if (sectionsAllIdsSectionsAllowed.length) {
        getSectionsAllIdsSectionsAllowed = sectionsAllIdsSectionsAllowed
      } else {
        getSectionsAllIdsSectionsAllowed = this.getChildsSections(getDocumentsSections, [])
        this.setState({sectionsAllIdsSectionsAllowed: getSectionsAllIdsSectionsAllowed})
      }

      return data.reduce((accum, doc) => {
        const isAllowed = getSectionsAllIdsSectionsAllowed.includes(doc.id_seccion)
        if (isAllowed) accum.push(doc)
        return accum
      }, [])
    }
    return data
  }

  getChildsSections = (secciones, array) => {
    if (secciones?.selectable !== false) array.push(secciones.key)
    if (secciones.children.length) {
      secciones.children.map(newChild => {
        if (newChild.selectable !== false) array.push(newChild.key)
        if (newChild?.children && newChild.children.length) return this.getChildsSections(newChild, array)
      })

    }
    return array
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onPage', event);
    this.setState({ lazyParams: _lazyParams }, this.loadData);
  };

  sendCommentToBitacora = async (data, justification) => {
    const { sendActionToBitacora, getDetailSection, getDetailDocument } = this.props
    const { transactionNameOpt } = this.state
    let nameDocument = ''
    if (data.id_original) {
      const response = await getDetailDocument({id: data.id_original, setToState: false})
      console.log('Respuesta de detalle original: ' , response)
      if (!response?.status) nameDocument = response.data.nombre[LANGUAGE_DEFAULT]
      else nameDocument = data.nombre[LANGUAGE_DEFAULT].name
    } else {
      nameDocument = data.nombre[LANGUAGE_DEFAULT]
    }
    const dataBitacora = {
      transactionName: transactionNameOpt || 'Documento',
      reason: `${nameDocument} || ${justification}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

  onChangeVisibleStatus = async (data, justification) => {
    const { t, updateVisibilityStatus } = this.props;
    this.setState({loadingTable: true})
    const response = await updateVisibilityStatus({...data, justification});
    if (!response?.status) {
      await this.setState({transactionNameOpt: data.visible === StatusVisible.IS_VISIBLE ? 'ocultarDocumento' : 'mostrarDocumento' })
      await this.sendCommentToBitacora(data, justification)
      this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  };

  onConfirmVisible = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        continueAction: ({justification}) => this.onChangeVisibleStatus(data, justification),
      },
    });
  };

  onConfirmDeleteSeccion = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{DOCUMENTO}}?', {DOCUMENTO: getValueLanguageObj(data.name)}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteDocument(data, justification),
      },
    });
  };

  onConfirmDeleteAuthorized = (data) => {
    this.setState({
      showModalDeleteAuthorized: {
        isVisible: true,
        data
      }
    });
  }

  onDeleteDocument = async (data, justification) => {
    const { t, deleteDocument } = this.props;
    const { selectedNavegationTreeSearch } = this.state
    this.setState({loadingTable: true})
    const type = "logical"
    const response = await deleteDocument({id: data.id, type, justification, selectedNavegationTree: data.id_seccion});
    if (!response?.status) {
      await this.setState({transactionNameOpt: 'bajaDocumento' })
      await this.sendCommentToBitacora(data, justification)
      await this.loadData();
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  };

  onEditDocument = async (node) => {
    const { history } = this.props;
    const { selectedNavegationTreeSearch } = this.state;
    history.push({
      pathname: '/document/edit',
      state: { clearCache: true, id: node.id, selectedNavegationTree: node.id_seccion },
    });
  };

  onPendingDocument = async (node) => {
    const { history } = this.props;
    history.push({
      pathname: '/document/edit',
      state: { clearCache: true, id: node.id, isPending: true },
    });
  };

  onReportDocument = async (node) => {
    const { history } = this.props;
    history.push({
      pathname: '/document/report',
      state: { id: node.id, detail: node },
    });
  };

  templateName = (node, detail) => {
    let icon = '';
    if (node.tipo === 'URL') icon = 'pi-link';
    if (node.tipo === 'DOCTO')
      icon = 'pi-file-pdf';
    if (node.tipo === 'HTML')
      icon = 'pi-align-justify';
    return (
      <>
        <span className="p-column-title">{detail.header}</span>
        <i className={`pi ${icon} p-pr-3`} />
        {getValueLanguageObj(node.nombre)}
      </>
    );
  };

  templateAuthorized = (node, detail) => {
    const { t } = this.props;
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check p-mr-2"></i>
        </div>
      );
    }
    if (node.estatus === AuthorizedStatus.STATUS_PENDING) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-blue cursor-pointer" onClick={() => this.onPendingDocument(node)}> {t('PENDIENTE')} </span>
        </>
      );
    }
    if (node.estatus === AuthorizedStatus.STATUS_EDITION) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-green"> {t('EN EDICIÓN')} </span>
        </>
      )
    }
    if (node.estatus === AuthorizedStatus.STATUS_REJECTED) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red"> {t('RECHAZADO')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  };

  templateVisible = (node, detail) => {
    const { t, validatePermissionAction } = this.props;
    const hasPermissionShowHiddenDocument = validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_DOCUMENTO)
    if (node.visible === StatusVisible.IS_VISIBLE && node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && node.eliminado === StatusDelete.IS_VISIBLE ) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-check"
            className={`p-button-text ${hasPermissionShowHiddenDocument ? '' : 'cursor-not-pointer'}`}
            style={{ marginRight: '.5em' }}
            onClick={hasPermissionShowHiddenDocument ? () => this.onConfirmVisible(node) : () => {}}
          />
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_VISIBLE && node.id_original !== 0) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className={`pi pi-check cursor-pointer ${hasPermissionShowHiddenDocument ? 'cursor-pointer' : 'cursor-not-pointer'}`} onClick={hasPermissionShowHiddenDocument ? () => this.onConfirmVisible(node) : () => {}}/>
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_VISIBLE ) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check" />
        </div>
      );
    }

    if (node.visible === StatusVisible.IS_HIDDEN && (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED || node.id_original !== 0)) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red  ${hasPermissionShowHiddenDocument ? 'cursor-pointer' : 'cursor-not-pointer'}`} aria-hidden="true" onClick={hasPermissionShowHiddenDocument ? () => this.onConfirmVisible(node) : () => {}}> {t('OCULTA')} </span>
        </>
      );
    }
    if (node.visible === StatusVisible.IS_HIDDEN) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red cursor-not-pointer`} aria-hidden="true" > {t('OCULTA')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  };

  templateEdit = (node, detail) => {
    if ( node.eliminado !== StatusDelete.CONFIRM_DELETE ) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => this.onEditDocument(node)}
          />
        </div>
      )
    }
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
      </div>
    )
  };

  templateDelete = (node, detail) => {
    const { t } = this.props
    // if (node.authorizedId !== AuthorizedStatus.STATUS_AUTHORIZED) return (<span className="p-column-title">{detail.header}</span>);
    if (documentsExceptionsDelete.find(item => item === node.id)) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
        </div>
      )
    }
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && node.eliminado === StatusDelete.CONFIRM_DELETE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-yellow cursor-pointer" onClick={() => this.onConfirmDeleteAuthorized(node)}> {t('Eliminado')} </span>
        </>
      )
    }
    if (node.estatus === AuthorizedStatus.STATUS_AUTHORIZED && node.eliminado === StatusDelete.IS_VISIBLE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-trash"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => this.onConfirmDeleteSeccion(node)}
          />
        </div>
      );
    }
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
      </div>
    )
  };

  templateReadings = (node, detail) => {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-book"
            className="p-button-text"
            style={{ marginRight: '.5em' }}
            onClick={() => this.onReportDocument(node)}
          />
        </div>
      );
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  onHideModalDeleteAuthorized = () => {
    this.setState({
      showModalDeleteAuthorized: {
        isVisible: false,
      },
    });
  };

  onChange = ({target}) => {
    this.setState({ [target.name]: target.value });
  };

  onChangeCategoriesSection = ({ value, label }) => {
    this.setState({
      selectedNavegationTree: value,
      selectedLabelNavegationTree: label,
    });
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  columnAuthorizedDate = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData?.fecha_autorizacion ? moment(rowData.fecha_autorizacion).locale(this.props.i18n.language).format("DD MMMM YYYY") : ""}
    </>
  )

  onRowReorder = (newOrden) => {
    const { reOrderDocument } = this.props
    const { sectionList } = this.state
    const formatData = newOrden.value.reduce((accum, item, index) => {
      if (item?.id_original !== 0) accum.push({ id: item.id_original, orden: sectionList[index].orden})

      accum.push({ id: item.id, orden: sectionList[index].orden})
      return accum
    }, [])
    const response = reOrderDocument(formatData)
    if (!response.status) {
      this.setState({sectionList: newOrden.value})
    }
  }

  render() {
    const { history, t, validatePermissionAction } = this.props;
    const {
      loadingTable,
      sectionList,
      lazyParams,
      showModalJustification,
      selectedLabelNavegationTree,
      selectedNavegationTree,
      selectedNavegationTreeSearch,
      findText,
      showModalDeleteAuthorized
    } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.AGREGAR_DOCUMENTO) && (
          <Button
            label={t('Agregar Documento')}
            className="p-button-primary"
            onClick={() =>
              history.push({
                pathname: '/document/new',
                state: { clearCache: true, selectedNavegationTree: selectedNavegationTreeSearch },
              })
            }
          />
        )}
      </>
    );

    const headerTable = (
      <div className="p-grid">
        {/* <div className="p-col-12 p-md-7 p-lg-7 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('Filtrado por')}:</label>{' '}
          <CategoriesSectionTree
            value={selectedNavegationTree}
            label={selectedLabelNavegationTree}
            onChangeCategorie={this.onChangeCategoriesSection}
          />
        </div> */}
        <div className="p-col-12 p-md-12 p-lg-12 p-d-flex p-ai-center p-flex-column p-flex-sm-row p-jc-sm-center ">
          <div className="p-col p-d-flex p-ai-center is-full-width">
            <label className="p-mr-2 p-text-bold">{t('Filtrado por')}:</label>{' '}
            <CategorieSectionDocumentTree
              value={selectedNavegationTree}
              label={selectedLabelNavegationTree}
              onChangeCategorie={this.onChangeCategoriesSection}
            />
          </div>
          <div className="p-col is-full-width">
            <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
            <InputText
              name="findText"
              value={findText}
              onChange={this.onChange}
              className="p-mr-2 input-search-list"
            />
            <Button
              icon="pi pi-search"
              label={t('Buscar')}
              className="p-button-raised p-button-text p-button-plain btn-search-list"
              onClick={() => this.loadData()}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Documentos')} rightComponent={rightHeader} />
          <div className="card">
            <DataTable
              value={sectionList}
              lazy
              // paginator
              // rows={lazyParams.rows}
              loading={loadingTable}
              first={lazyParams.first}
              // onPage={this.onPage}
              header={headerTable}
              className="table-documents"
              onRowReorder={this.onRowReorder}
            >
              { validatePermissionAction(catalogPermissionsId.ORDENAR_DOCUMENTO) && (
                <Column
                  header={t('Orden')}
                  rowReorder
                  style={{width: '4em'}}
                  className="sm-invisible"
                />
              )}
              <Column
                field="name"
                header={t('Nombre')}
                body={this.templateName}
              />
              <Column
                header={t('Fecha de actualización')}
                body={this.columnAuthorizedDate}
                className="p-text-center-lg"
              />
              <Column
                header={t('Autorizado')}
                body={this.templateAuthorized}
                className="column-authorized"
              />
              { validatePermissionAction(catalogPermissionsId.EDITAR_DOCUENTO) && (
                <Column
                  header={t('Editar')}
                  body={this.templateEdit}
                  className="column-action"
                />
              )}
              <Column
                header={t('Visible')}
                body={this.templateVisible}
                className="column-action"
              />
              { validatePermissionAction(catalogPermissionsId.ELIMINAR_DOCUMENTOS_AUTORIZADOS) && (
                <Column
                  header={t('Eliminar')}
                  body={this.templateDelete}
                  className="column-action"
                />
              )}
              { validatePermissionAction(catalogPermissionsId.VER_REPORTE_LECTORES) && (
                <Column
                  header={t('Lectores')}
                  body={this.templateReadings}
                  className="column-action"
                />
              )}
            </DataTable>
            { !sectionList.length && !loadingTable && (
              <div className="p-col-12 not-information">
                {t('No se encontraron resultados')}
              </div>
            )}
          </div>
        </div>
        
        <Toast ref={(el) => (this.toast = el)} />
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        <DeleteAuthorizedModal
          display={showModalDeleteAuthorized.isVisible}
          data={showModalDeleteAuthorized.data}
          onHidden={() => this.onHideModalDeleteAuthorized()}
          onContinueAction={() => this.loadData()}
          sectionTree={selectedNavegationTreeSearch}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  allowedSections: state.sessionPermission.secciones,
  categoriesSectionCatalog: state.catalogs.sectionTreeCurrentCatalog,
})

const mapDispatchToProps = {
  getDocuments,
  updateVisibilityStatus,
  deleteDocument,
  reOrderDocument,
  validatePermissionAction,
  sendActionToBitacora,
  getDetailDocument
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Documents);
